<template>
  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M11 12.6553C4.38983 12.6553 0.74939 15.8489 0.74939 21.648C0.74939 22.1009 1.10882 22.468 1.5523 22.468H20.4477C20.8912 22.468 21.2506 22.1009 21.2506 21.648C21.2506 15.8492 17.6102 12.6553 11 12.6553ZM2.38444 20.828C2.70026 16.4921 5.59476 14.2953 11 14.2953C16.4053 14.2953 19.2998 16.4921 19.6159 20.828H2.38444Z" class="icon-fill"/>
      <path d="M11 0C7.96365 0 5.67401 2.38539 5.67401 5.54843C5.67401 8.80411 8.06325 11.4524 11 11.4524C13.9368 11.4524 16.3261 8.80411 16.3261 5.5487C16.3261 2.38539 14.0364 0 11 0ZM11 9.81272C8.94858 9.81272 7.27984 7.8999 7.27984 5.5487C7.27984 3.28385 8.84446 1.63999 11 1.63999C13.1211 1.63999 14.7202 3.32019 14.7202 5.5487C14.7202 7.8999 13.0515 9.81272 11 9.81272Z" class="icon-fill"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="22" height="22.4681" fill="white"/>
      </clipPath>
    </defs>
  </svg>


</template>

<script>
export default {
  name: 'user'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>